var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNew3DIcon = function SvgNew3DIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 71.16 40.29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{stroke:#d7d7db;stroke-miterlimit:10;stroke-width:1.58px;}.cls-2{stroke:#15152a;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.8px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.77,
    y1: 11.22,
    x2: 18.71,
    y2: 19.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.7,
    y1: 2.23,
    x2: 17.7,
    y2: 38.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.92,
    y1: 30.22,
    x2: 15.48,
    y2: 38.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.95,
    y1: 37.37,
    x2: 31.81,
    y2: 30.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.74,
    y1: 1.58,
    x2: 1.18,
    y2: 10.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.95,
    y1: 12.28,
    x2: 0.95,
    y2: 27.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.11,
    y1: 15.73,
    x2: 34.11,
    y2: 26.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.51,
    y1: 20.32,
    x2: 33.67,
    y2: 29.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.19,
    y1: 10.23,
    x2: 15.39,
    y2: 18.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.2,
    y1: 1.16,
    x2: 32.81,
    y2: 9.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.79,
    y1: 26.85,
    x2: 16.65,
    y2: 20.31
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "0.96 15.54 0.95 10.17 5.92 7.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.45,
    y1: 12.73,
    x2: 0.95,
    y2: 10.17
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "34.19 24.12 34.13 29.45 29.33 32.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "29.42 7.6 34.1 10.3 34.11 15.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 29.11,
    y1: 13.31,
    x2: 34.07,
    y2: 10.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "5.58 32.35 0.9 29.68 0.92 24.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.38,
    y1: 26.99,
    x2: 1.12,
    y2: 29.41
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.63 33.01 17.63 39.38 22.55 36.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17.65,
    y1: 39.39,
    x2: 12.99,
    y2: 36.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 33.98,
    y1: 29.19,
    x2: 29.4,
    y2: 26.69
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.71 25.15 17.74 19.87 22.59 17.11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17.6,
    y1: 19.83,
    x2: 12.94,
    y2: 17.17
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.72 6.26 17.7 0.91 12.8 3.59"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17.87,
    y1: 0.9,
    x2: 22.6,
    y2: 3.58
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.23,19a3.28,3.28,0,0,1,1,2.52,3.56,3.56,0,0,1-.53,1.93,3.64,3.64,0,0,1-1.55,1.33,5.81,5.81,0,0,1-2.52.49,7.48,7.48,0,0,1-2.6-.45,5.23,5.23,0,0,1-2-1.18l.63-1a4.79,4.79,0,0,0,1.69,1.06,6.14,6.14,0,0,0,2.24.4,3.8,3.8,0,0,0,2.41-.67,2.3,2.3,0,0,0,.85-1.88,2.22,2.22,0,0,0-.85-1.84A4.11,4.11,0,0,0,51.51,19H50.6V18l3.51-4.4H47.63V12.48h8.15v.92L52.2,17.91A4.68,4.68,0,0,1,55.23,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.22,12.48h5.15a7.52,7.52,0,0,1,3.55.81,5.81,5.81,0,0,1,2.39,2.24,6.33,6.33,0,0,1,.85,3.29,6.29,6.29,0,0,1-.85,3.28,5.81,5.81,0,0,1-2.39,2.24,7.52,7.52,0,0,1-3.55.81H59.22ZM64.3,24a6.12,6.12,0,0,0,2.91-.66,4.76,4.76,0,0,0,1.94-1.83,5.14,5.14,0,0,0,.69-2.68,5.18,5.18,0,0,0-.69-2.69,4.76,4.76,0,0,0-1.94-1.83,6.12,6.12,0,0,0-2.91-.66H60.56V24Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNew3DIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new_3D_icon.b7f26b21.svg";
export { ForwardRef as ReactComponent };